import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { Icon } from '@iconify/react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import URLs from 'src/api/url'
import { track } from '@amplitude/analytics-browser'
import { CoreButton, CoreTextField } from 'src/components/core'
const EmbedView = props => {
  const { classes, entity } = props
  const [copiedEmbedCode, setCopiedEmbedCode] = React.useState(false)
  const [copiedEmbedCode2, setCopiedEmbedCode2] = React.useState(false)

  const onClickEmbedCode = () => {
    track(`collection_share_popup_embed_clicked`, {
      type: 'head',
    })

    setCopiedEmbedCode(true)
    setTimeout(() => {
      setCopiedEmbedCode(false)
    }, 500)
  }
  const onClickEmbedCode2 = () => {
    setCopiedEmbedCode2(true)
    track(`collection_share_popup_embed_clicked`, {
      type: 'body',
    })

    setTimeout(() => {
      setCopiedEmbedCode2(false)
    }, 500)
  }
  return (
    <div className={classes.customDomain__root}>
      <Typography fontSize={'14px'} fontWeight={400} fontFamily={'Inter'}>
        You can embed the learning path on your website with JavaScript code.
      </Typography>
      <Typography fontSize={'14px'} fontWeight={400} fontFamily={'Inter'}>
        Add the following codes to the{' '}
        <span
          style={{
            color: '#015ffb',
          }}
        >
          {' <head> '}
        </span>{' '}
        tag of your site.
      </Typography>
      <CoreTextField
        fullWidth
        disabled={true}
        marginTop={false}
        value={
          '<meta http-equiv="Access-Control-Allow-Origin" content="' +
          URLs.APP_URL +
          '" />' +
          '<script src="' +
          URLs.APP_URL +
          'viewer.js"></script>' +
          '<script>' +
          'const app = new MiniCourse();' +
          'document.addEventListener("DOMContentLoaded", function () {' +
          'app.init({categoryId: "' +
          entity.id +
          '"});' +
          '});' +
          '</script>'
        }
      />

      <CopyToClipboard
        text={`<meta http-equiv="Access-Control-Allow-Origin" content="{0}" />
                    <script src="{1}viewer.js"></script>
                    <script>
                      const app = new MiniCourse();

                      document.addEventListener("DOMContentLoaded", () => {
                        app.init({
                          categoryId: "{2}"
                        })
                      })
                    </script>`
          .replace('{0}', URLs.APP_URL)
          .replace('{1}', URLs.APP_URL)
          .replace('{2}', entity.id)}
      >
        <CoreButton
          onClick={onClickEmbedCode}
          variant="contained"
          color="primary"
          fullWidth
        >
          {copiedEmbedCode ? 'Copied!' : 'Copy to Clipboard'}
        </CoreButton>
      </CopyToClipboard>

      <Typography
        color={'#002E47'}
        fontSize={'14px'}
        fontWeight={400}
        fontFamily={'Inter'}
      >
        Add the following codes to the{' '}
        <span
          style={{
            color: '#015ffb',
          }}
        >
          {'<body>'}
        </span>{' '}
        tag of your site.
      </Typography>
      <CoreTextField
        fullWidth
        value={'<div id="mcg-category-' + entity.id + '"></div>'}
        disabled={true}
        marginTop={false}
      />

      <CopyToClipboard text={'<div id="mcg-category-' + entity.id + '"></div>'}>
        <CoreButton
          onClick={onClickEmbedCode2}
          variant="contained"
          color="primary"
          fullWidth
        >
          {copiedEmbedCode2 ? 'Copied!' : 'Copy to Clipboard'}
        </CoreButton>
      </CopyToClipboard>
    </div>
  )
}

export default withStyles(styles)(EmbedView)
